import styled from 'styled-components'
import Filter from '../../../../assets/icons/filter.svg'

export const Container = styled.div`
    max-width: 6rem;
`

export const FilterIcon = styled(Filter)`
    width: 1rem;
    height: 1rem;
`
